import {
  postRequest,
  postFormDataRequest,
  getRequest
} from "../lib/utils/request";

export const getTokenAPI = async (apiHost, data, requestData) => {
  return await postRequest(
    `${apiHost}/v1/auth/admin/get-token`,
    data,
    requestData
  );
};

export const refreshTokenAPI = async (apiHost, data, requestData) => {
  return await getRequest(
    `${apiHost}/v1/auth/admin/refresh-token`,
    requestData
  );
};



// WEBPACK FOOTER //
// ./src/common/auth/api.js